import { makeLaboratoryHooks } from 'laboratory-hooks';
import { laboratoryClient } from '../api/laboratory';
const {
  useTreatment,
  TreatmentProvider
} = makeLaboratoryHooks(laboratoryClient);
export { useTreatment, TreatmentProvider };